"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  color: {
    primary: '#ADC4F8',
    secondary: '#222A3E',
    tertiary: '#528FD9',
    alert: '#DC8F98',
    white: '#FFFFFF',
    black: '#000'
  },
  fontSize: {
    large: '22px',
    regular: '16px',
    small: '12px'
  },
  flexColumns: 12
};
exports["default"] = _default;